import api from "./index.js";

// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return api({
    url: "/system/dict/data/type/" + dictType,
    method: "get",
  });
}

export const getRouters = () => {
  return api({
    url: '/system/menu/getRouters',
    method: 'get'
  })
}

export const getUserInfo = () => {
  return api({
    url: '/system/user/getInfo',
    method: 'get'
  })
}

export const getProjectList = (params) => {
  return api({
    url: '/system/project/list',
    headers: {
      isService: true,
      noLoading: true,
    },
    method: 'get',
    params
  })
}

export const getParkclient = (params) => {
  return api({
    url: '/park/parkclient/list',
    headers: {
      noLoading: true,
    },
    method: 'get',
    params
  })
}

export const userBindClient = (data) => {
  return api({
    url: '/park/clientUser/userBindClient',
    method: 'post',
    data
  })
}

export const updataClientStatus = (data) => {
  return api({
    url: '/park/parkclient/updateStatus',
    method: 'post',
    data
  })
}

export const getClientStatus = (params) => {
  return api({
    url: '/park/parkclient/getStatus',
    method: 'get',
    params
  })
}